let previousTimeEvent;

exports.playing = component => {
  component.isPlaying = true;
  if (component.externalAudio) {
    component.audioPlayer.currentTime = component.currentTime + 1;
    component.audioPlayer.play();
  }
};

exports.timeChanged = (component, e) => {
  if (!component.seeking && !component.videoIsLive) {
    component.currentTime = e.time;

    const roundedTime = Math.round(e.time);

    if (component.$store.getters.getPlayer.config.sendTimeEvents) {
      if (roundedTime !== previousTimeEvent) {
        previousTimeEvent = roundedTime;
        component.$store.dispatch("sendTimeEvent", 
          { 
            app: "virtual", 
            videoTime: Math.round(e.time), 
            videoName: component.$store.getters.getCurrentVideo.name 
          }
        );
      }
    }
  }
};

exports.stallStarted = component => {
  component.bufferDialog = true;
  if (component.externalAudio) {
    component.audioPlayer.pause();
  }
  if (component.videoIsLive) {
    if (component.$store.getters.getNextEvent.status === "done") {
      component.$router.push("Likes");
    } else {
      component.bufferTimeout = setTimeout(() => {
        component.bufferDialog = false;
        component.$router.push("Likes");
      }, 15000);
    }
  } else {
    component.bufferTimeout = setTimeout(() => {
      component.bufferDialog = false;
      component.currentTime -= 1;
      component.player.seek(component.currentTime);
      if (component.externalAudio) {
        component.audioPlayer.currentTime = component.currentTime + 1;
        component.audioPlayer.play();
      }
    }, 10000);

  }
};

exports.stallEnded = component => {
  component.bufferDialog = false;
  if (component.externalAudio) {
    component.audioPlayer.currentTime = component.currentTime + 1;
    component.audioPlayer.play();
  }
  clearTimeout(component.bufferTimeout);
};

exports.paused = component => {
  component.isPlaying = false;
  if (component.externalAudio) {
    component.audioPlayer.pause();
  }
};

exports.muted = component => {
  component.isMuted = true;
  if (component.externalAudio) {
    component.audioPlayer.mute();
  }
};

exports.unmuted = component => {
  component.isMuted = false;
  if (component.externalAudio) {
    component.audioPlayer.unmute();
  }
};

exports.playbackFinished = component => {
  component.$router.push("Likes");
};


// WEBPACK FOOTER //
// ./src/components/player/PlayerEvents.js